export default __webpack_public_path__ + "media/components/Pages/Abitur/Images/How/5-dac1a9c7365c5611b6032c0098c1e1f5.svg";